(function () {
  'use strict';
  if (window.swInquiryReady) return;
  window.swInquiryReady = true;
  if (!window.fetch || !window.FormData || !window.crypto || !crypto.randomUUID) return;

  var CONSENT = 'contact[Akceptacja polityki prywatności]';
  var REFERENCE = 'contact[Załącznik]';

  function init() {
    document.querySelectorAll('[data-sw-inquiry]').forEach(function (box) {
      box.hidden = false;
      if (box.dataset.ready) return;
      box.dataset.ready = '1';
      var file = box.querySelector('[data-sw-inquiry-file]');
      var clear = box.querySelector('[data-sw-inquiry-clear]');
      clear.hidden = !file.files.length;
      clear.addEventListener('click', function () {
        file.value = '';
        file.dispatchEvent(new Event('change', { bubbles: true }));
        file.focus();
      });
      file.addEventListener('change', function () {
        clear.hidden = !file.files.length;
        box.querySelector('[data-sw-inquiry-status]').textContent = '';
        box.querySelector('[data-sw-inquiry-reference]').disabled = true;
        delete box.dataset.requestId;
        delete box.dataset.sent;
      });
    });
  }
  init();
  document.addEventListener('shopify:section:load', init);

  // Migawka treści bez pól, które zmieniają się między przebiegami: czasu zgody
  // (wpisuje go skrypt sekcji przy każdym submit) i samego pola z linkiem.
  function signatureOf(form, file) {
    var fields = Array.from(new FormData(form).entries()).filter(function (entry) {
      return typeof entry[1] === 'string' && entry[0].indexOf('contact[') === 0 && entry[0] !== CONSENT && entry[0] !== REFERENCE;
    });
    return JSON.stringify([fields, file.name, file.size, file.lastModified]);
  }

  function submitAgain(form, submitter) {
    var button = submitter && submitter.form === form ? submitter : null;
    if (form.requestSubmit) {
      try { form.requestSubmit(button || undefined); return; } catch (e) {}
    }
    button = button || form.querySelector('[type=submit]');
    if (button) button.click(); else HTMLFormElement.prototype.submit.call(form);
  }

  // Poprawka 15.10.2026: słuchamy w fazie PRZECHWYTYWANIA na window, czyli przed
  // skryptami sekcji i przed hCaptchą Shopify. hCaptcha wstrzymuje każdy submit
  // formularza kontaktowego (preventDefault), a poprzednia wersja na to czekała
  // (`event.defaultPrevented` = rezygnacja), więc plik nie wychodził nigdy, a
  // wiadomość szła bez niego. Teraz: zapis pliku, link w polu „Załącznik", potem
  // requestSubmit() - drugi przebieg idzie już zwykłą drogą (walidacja sekcji,
  // czas zgody, return_to, CAPTCHA i komunikaty Shopify).
  window.addEventListener('submit', function (event) {
    var form = event.target;
    var box = form && form.querySelector && form.querySelector('[data-sw-inquiry]');
    if (!box) return;
    var input = box.querySelector('[data-sw-inquiry-file]');
    var file = input.files[0];
    var reference = box.querySelector('[data-sw-inquiry-reference]');
    if (!file) { reference.disabled = true; return; }
    var signature = signatureOf(form, file);
    // Drugi przebieg - plik już zapisany dla tej samej treści.
    if (box.dataset.sent === signature && !reference.disabled) return;
    // Błędy w polach pokazuje skrypt sekcji; pliku nie zapisujemy przed zgodą
    // i poprawną treścią. Ten przebieg i tak zostanie zatrzymany przez sekcję.
    if (!form.checkValidity()) { reference.disabled = true; return; }
    event.preventDefault();
    event.stopImmediatePropagation();
    if (box.dataset.busy) return;
    upload(form, box, file, reference, signature, event.submitter);
  }, true);

  async function upload(form, box, file, reference, signature, submitter) {
    var status = box.querySelector('[data-sw-inquiry-status]');
    function problem(message) { status.textContent = message; status.focus(); }
    if (!file.size || file.size > 5 * 1024 * 1024 || !['image/jpeg', 'image/png', 'image/webp'].includes(file.type)) {
      problem('Wybierz niepusty plik JPG, PNG lub WebP do 5 MB albo usuń plik i wyślij bez niego.');
      return;
    }
    // Ta sama treść = ten sam numer, więc ponowienie po utracie odpowiedzi nie dubluje zapisu.
    if (box.dataset.snapshot !== signature || !box.dataset.requestId) {
      box.dataset.requestId = crypto.randomUUID();
      box.dataset.snapshot = signature;
    }
    reference.disabled = true;
    var data = new FormData(form);
    data.delete(CONSENT);
    data.set('file', file);
    data.set('requestId', box.dataset.requestId);
    box.dataset.busy = '1';
    form.setAttribute('aria-busy', 'true');
    var controls = Array.from(form.elements).filter(function (el) { return !el.disabled; });
    controls.forEach(function (el) { el.disabled = true; });
    status.textContent = 'Zapisujemy załącznik…';
    var controller = new AbortController();
    var timeout = setTimeout(function () { controller.abort(); }, 30000);
    var saved = false;
    try {
      var response = await fetch('/apps/sw-configurator/inquiries', { method: 'POST', body: data, signal: controller.signal });
      var result = await response.json();
      if (!response.ok || typeof result.id !== 'string' || !/^[a-z0-9]{10,40}$/.test(result.id)) {
        throw new Error(result.error || 'Nie udało się zapisać załącznika.');
      }
      // Link otwiera plik bez logowania (podpisany, ważny 90 dni). Starszy backend
      // nie zwraca `url` - wtedy zostaje numer i miejsce w panelu aplikacji.
      reference.value = typeof result.url === 'string' && /^https:\/\/\S+$/.test(result.url)
        ? 'Plik od klienta: ' + result.url + ' (link ważny 90 dni)'
        : result.id + ' - plik: Shopify > aplikacja konfiguratora > Załączniki do zapytań (90 dni).';
      reference.disabled = false;
      box.dataset.sent = signature;
      status.textContent = 'Załącznik zapisany. Wysyłamy zapytanie…';
      saved = true;
    } catch (error) {
      problem((error.name === 'AbortError' ? 'Przekroczono czas zapisu załącznika.' : error.message) + ' Spróbuj ponownie lub usuń plik i wyślij bez niego.');
    } finally {
      clearTimeout(timeout);
      controls.forEach(function (el) { el.disabled = false; });
      delete box.dataset.busy;
      form.removeAttribute('aria-busy');
    }
    if (saved) submitAgain(form, submitter);
  }
})();
